/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_Upload_ProcessingInputs */

const en_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing...`)
};

const de_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird verarbeitet...`)
};

const fr_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement en cours...`)
};

const es_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando...`)
};

const it_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione...`)
};

const nl_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerken...`)
};

const pl_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzanie...`)
};

const fi_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsitellään...`)
};

const da_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandler...`)
};

const sv_onboarding_resume_upload_processing = /** @type {(inputs: Onboarding_Resume_Upload_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbetar...`)
};

/**
* | output |
* | --- |
* | "Processing..." |
*
* @param {Onboarding_Resume_Upload_ProcessingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_upload_processing = /** @type {((inputs?: Onboarding_Resume_Upload_ProcessingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_Upload_ProcessingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_upload_processing(inputs)
	if (locale === "fr") return fr_onboarding_resume_upload_processing(inputs)
	if (locale === "es") return es_onboarding_resume_upload_processing(inputs)
	if (locale === "it") return it_onboarding_resume_upload_processing(inputs)
	if (locale === "nl") return nl_onboarding_resume_upload_processing(inputs)
	if (locale === "pl") return pl_onboarding_resume_upload_processing(inputs)
	if (locale === "fi") return fi_onboarding_resume_upload_processing(inputs)
	if (locale === "da") return da_onboarding_resume_upload_processing(inputs)
	if (locale === "sv") return sv_onboarding_resume_upload_processing(inputs)
	return en_onboarding_resume_upload_processing(inputs)
});